import React from "react";
import {TextField} from "@fluentui/react";
import {calculateBundleItemPrice, IProductBundleItem} from "../../models/ProductBundles";

interface ProductBundleItemPriceEntryProps {
    item: IProductBundleItem;
    onChange?: (value?: number) => void;
    defaultMarkup?: number;
    defaultListDiscount?: number;
}

const ProductBundleItemPriceEntry: React.FC<ProductBundleItemPriceEntryProps> = (props) => {
    
    const [currentVal, setCurrentVal] = React.useState<string | undefined>(undefined);

    React.useEffect(() => {
        if (props.item.details?.price != null && props.item.details?.price !== 0) {
            setCurrentVal(props.item.details.price.toString());
        }
    }, [props.item.details?.price])

    let calculatedPrice = props.item
        ? calculateBundleItemPrice(props.item)
        : undefined;

    if((calculatedPrice === undefined) && props.item) {
        calculatedPrice = calculateBundleItemPrice(props.item, props?.defaultMarkup, props?.defaultListDiscount)
    }
    

    const update = (v: string | undefined) => {
        props?.onChange?.(v ? parseFloat(v) : undefined);
    }

    return (<>
        <TextField
            placeholder={calculatedPrice?.toString() ?? 'Not Set'}
            value={currentVal}
            prefix={'$'}
            type={'number'}
            className={'italic-placeholder'}
            onBlur={(e) => update(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    update(e.currentTarget.value);
                }
            }}
            onChange={(e, v) => {
                setCurrentVal(v);
            }}
        />
    </>)
}

export default ProductBundleItemPriceEntry;